import { createFileRoute } from "@tanstack/react-router";
import PageGate from "@/components/auth/PageGate";
import CourseDetail from "@/pages/CourseDetail";

export const Route = createFileRoute("/_app/learn/$pathId")({
  component: () => (
    <PageGate pageKey="learn"><CourseDetail /></PageGate>
  ),
});
